(function () {
  function getScrollAmount(track) {
    const card = track.querySelector('.testimonials__card');
    if (!card) return 340;
    const gap = parseFloat(getComputedStyle(track).gap) || 24;
    return card.offsetWidth + gap;
  }

  function updateArrowState(track, prevBtn, nextBtn) {
    if (!prevBtn || !nextBtn) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const tolerance = 2;

    prevBtn.disabled = track.scrollLeft <= tolerance;
    nextBtn.disabled = track.scrollLeft >= maxScroll - tolerance;
  }

  function initTestimonials(section) {
    const carousel = section.querySelector('[data-testimonials-carousel]');
    if (!carousel) return;

    const track = carousel.querySelector('[data-testimonials-track]');
    const prevBtn = carousel.querySelector('[data-testimonials-prev]');
    const nextBtn = carousel.querySelector('[data-testimonials-next]');
    if (!track) return;

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(track), behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(track), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      updateArrowState(track, prevBtn, nextBtn);
    });

    window.addEventListener('resize', function () {
      updateArrowState(track, prevBtn, nextBtn);
    });

    updateArrowState(track, prevBtn, nextBtn);
  }

  function initAll() {
    document.querySelectorAll('.testimonials').forEach(initTestimonials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.testimonials');
    if (section) initTestimonials(section);
  });
})();
